import {Injectable} from "@angular/core";
import {IOrderHistoryDateRange, IOrderHistoryView, IOrderHistoryViewProduct} from "../orders-models";
import {WrappedBehaviorSubject} from "../../cache/wrapped-behavior-subject";
import {UsanaObject} from "../../usana-object";
import {LoggerService} from "../../common/logger.service";

@Injectable({
    providedIn: 'root'
})
export class OrderHistoryCacheService extends UsanaObject {

    orderViewsSubject: WrappedBehaviorSubject<IOrderHistoryView[]> = new WrappedBehaviorSubject<IOrderHistoryView[]>();
    selectedDateRangeSubject: WrappedBehaviorSubject<IOrderHistoryDateRange> = new WrappedBehaviorSubject<IOrderHistoryDateRange>();
    dateRangesSubject: WrappedBehaviorSubject<IOrderHistoryDateRange[]> = new WrappedBehaviorSubject<IOrderHistoryDateRange[]>();
    activeOrderViewSubject: WrappedBehaviorSubject<IOrderHistoryView> = new WrappedBehaviorSubject<IOrderHistoryView>();
    orderAddingSubject: WrappedBehaviorSubject<number> = new WrappedBehaviorSubject<number>();
    productsAddingSubject: WrappedBehaviorSubject<Map<number, IOrderHistoryViewProduct[]>> = new WrappedBehaviorSubject<Map<number, IOrderHistoryViewProduct[]>>();

    constructor(loggerService: LoggerService) {
        super(loggerService);
    }

    getOrderViews(): IOrderHistoryView[] {
        return this.orderViewsSubject.value;
    }

    setOrderViews(orders: IOrderHistoryView[]) {
        this.orderViewsSubject.set(orders);
    }

    getDateRanges(): IOrderHistoryDateRange[] {
        return this.dateRangesSubject.value;
    }

    setDateRanges(dateRanges: IOrderHistoryDateRange[]) {
        this.dateRangesSubject.set(dateRanges);
    }

    getSelectedDateRange(): IOrderHistoryDateRange {
        return this.selectedDateRangeSubject.value;
    }

    setSelectedDateRange(dateRange: IOrderHistoryDateRange) {
        this.selectedDateRangeSubject.set(dateRange);
    }

    getActiveOrderView(): IOrderHistoryView {
        return this.activeOrderViewSubject.value;
    }

    setActiveOrderView(orderView: IOrderHistoryView) {
        this.activeOrderViewSubject.set(orderView);
    }

    addAllProductsAdding(orderId: number) {
        this.orderAddingSubject.set(orderId);
    }

    removeAllProductsAdding() {
        this.orderAddingSubject.clear();
    }

    addProductAdding(orderViewProduct: IOrderHistoryViewProduct, orderId: number) {
        const orderViewProductsMap = new Map(this.productsAddingSubject.get());
        const orderViewProducts = orderViewProductsMap.get(orderId) || [];
        orderViewProducts.push(orderViewProduct);
        orderViewProductsMap.set(orderId, orderViewProducts);
        this.productsAddingSubject.set(orderViewProductsMap);
    }

    removeProductAdding(viewProduct: IOrderHistoryViewProduct, orderId: number) {
        const orderViewProductsMap = new Map(this.productsAddingSubject.get());
        const orderViewProducts = orderViewProductsMap.get(orderId);

        if (orderViewProducts) {
            const filteredProducts = orderViewProducts.filter(p =>!(viewProduct.id === p.id && viewProduct.mhpId === p.mhpId));
            if (filteredProducts.length === 0) {
                orderViewProductsMap.delete(orderId);
            } else {
                orderViewProductsMap.set(orderId, filteredProducts);
            }

            this.productsAddingSubject.set(orderViewProductsMap);
        }
    }

    clearOrderHistory(): void {
        this.orderViewsSubject.clear();
        this.dateRangesSubject.clear();
        this.selectedDateRangeSubject.clear();
        this.activeOrderViewSubject.clear();
    }
}
